<p-button
    icon="pi pi-filter-fill"
    [rounded]="true"
    [text]="true"
    [pTooltip]="l('::Filter')"
    tooltipPosition="right"
    [label]="l('::Filter')"
    (onClick)="onClick()">    
</p-button>